import React from 'react';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';

import { ButtonText, ButtonIcon } from '../buttons';

/**
 * SecondaryRaisedButton base component.
 *
 * @param props
 * @returns {XML}
 * @constructor
 */
const SecondaryRaisedButton = ({ text, icon, handleClick, ...props }) => {
    const StyledButton = styled(Button)`
        &.stolo-button-secondary-raised {
            position: relative;
            ${props => props.theme.typography.button};
            display: inline-flex;
            align-items: center;
            height: 100%;
            width: 100%;
            color: white;
            text-align: center;
            margin: ${props => props.theme.space[8]} 0;
            padding: ${props => props.theme.space[4]} ${props => props.theme.space[6]}};
            line-height: 1;
        }

        & {
          padding: 0.25em;
        }
    `;

    const Icon = icon ? <ButtonIcon icon={icon} iconColor={'common.white'} /> : null;
    return (
        <StyledButton classes={{ raisedSecondary: 'stolo-button-secondary-raised' }} color='secondary' variant='raised' onClick={handleClick} {...props}>
            {Icon}
            <ButtonText buttonText={text} />
        </StyledButton>
    );
};


export default SecondaryRaisedButton;



// WEBPACK FOOTER //
// ./src/components/buttons/SecondaryRaisedButton.js